/**
 * Viewer Selector
 */

import { Connection } from '../../utils/relay';

export interface IPropsWithViewer {
  viewer?: GQL.IViewer;
}

export type GetConnectionFromViewer<N> = (props: IPropsWithViewer) => Connection<N> | null;
export type GetNodeFromViewer<N> = (props: IPropsWithViewer) => N | null;

export const getViewer = ({ viewer }: IPropsWithViewer) => viewer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectors/viewer.ts